import { TicketAction } from 'Pages/TicketPage/Redux/actions';

export interface ITicket {
  isFetching: boolean;
  isFetchFailed: boolean;
  isTicketNotFound: boolean;
  ticketSummary: Julius.Website.TicketSummaryViewModel;
}

const initialTicket: ITicket = {
  isFetching: false,
  isFetchFailed: false,
  isTicketNotFound: false,
  ticketSummary: null,
};

function ticket(
  state: ITicket = initialTicket, 
  action: TicketAction,
  ): ITicket {

  switch (action.type) {      
    case 'SET_TICKET_SUMMARY':
      return {
        ...state,
        ticketSummary: action.ticketSummary,
        isFetching: false,
        isFetchFailed: false,
        isTicketNotFound: false,
      };

    case 'SET_IS_FETCHING_TICKET':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
        isTicketNotFound: false,
      };
    
    case 'SET_FETCH_TICKET_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
        isTicketNotFound: false,
      };

    case 'SET_TICKET_NOT_FOUND':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: false,
        isTicketNotFound: true,
      };

    default:
      return state;
  }
}

export default ticket;


// WEBPACK FOOTER //
// ./src/pages/TicketPage/Redux/reducer.tsx